import { SalesCampaignStatusEnums } from './share-type'

export const SalesCampaignStatusOptions = [
  {
    text: '激活',
    label: '激活',
    value: SalesCampaignStatusEnums.ACTIVE,
  },
  {
    label: '仅限内部',
    text: '仅限内部',
    value: SalesCampaignStatusEnums.INTERNAL_ONLY,
  },
  {
    label: '已失效',
    text: '已失效',
    value: SalesCampaignStatusEnums.INACTIVE,
  },
]
